import { combineReducers } from "redux";
import reducer from './reducer';

// 1. पहले combineReducers को एक अलग नाम (appReducer) देते हैं
const appReducer = combineReducers({
    reducer: reducer,
});

// 2. अब एक नया rootReducer function बनाते हैं जो RESET_STORE को handle करे
const rootReducer = (state, action) => {
    // 🔥 अगर RESET_STORE action आया, तो state को undefined कर दो
    if (action.type === 'RESET_STORE') {
        state = undefined;
    }
    
    // अब appReducer को नया state (या undefined) पास करो
    // जब state undefined होगा, combineReducers अपने आप सारे slices को उनकी initial state पर reset कर देगा
    return appReducer(state, action);
};

export default rootReducer;